import { Component, inject, input, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  UntypedFormGroup,
} from '@angular/forms';
import { ButtonComponent } from '@components';

@Component({
  selector: 'app-form-submit-button',
  templateUrl: './form-submit-button.component.html',
  styleUrls: ['./form-submit-button.component.scss'],
  imports: [ButtonComponent],
  standalone: true,
})
export class FormSubmitButtonComponent implements OnInit {
  readonly loading = input(false);
  readonly fill = input(false);

  private readonly controlContainer = inject(ControlContainer);
  form?: UntypedFormGroup =
    this.controlContainer instanceof FormGroupDirective
      ? this.controlContainer.form
      : undefined;

  ngOnInit(): void {
    if (!(this.controlContainer instanceof FormGroupDirective)) {
      return console.error(
        'FormSubmitButtonComponent must be used inside a form group',
      );
    }
  }

  get disabled(): boolean {
    const formDisabled = this.form?.disabled ?? false;
    return this.loading() || formDisabled;
  }
}
